import LoginPinMobileAssistant from './container'
export { LoginPinMobileAssistant }
export default LoginPinMobileAssistant